const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['sentry'] = require('../middleware/sentry.js')
middleware['sentry'] = middleware['sentry'].default || middleware['sentry']

export default middleware
